import React, { useState, useEffect ,useRef} from 'react';
import { Button, Table, Spin, Form, Input, Tabs, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined,HomeOutlined, SearchOutlined, RedoOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Config } from "../../public/js/config";
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//審核彈框
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import trans from './translation';
import Message from '../../component/message/message';
import './wilPwdManage.css';

const { TabPane } = Tabs;

const WilPwdManage = (props) => {
    
    const [form] = Form.useForm();
    const messageRef = useRef();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isLeave, setIsLeave] = useState(false);
    const [genderList, setGenderList] = useState([]);
    const [userModel, setUserModel] = useState({});
    const tableColumns = {
        userId: "sys_user_id",
        userName: "user_code"
    }

    useEffect(() => {
        search(pageSize, 1, "N");
        searchGender();
    }, []);

    /**称谓下拉 */
    const searchGender = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "TITLE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                setGenderList(data.object ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if(Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("user/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model =>{
            return {...model,...{[key]:value}};
        });
    }
    
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if(key === "2" && Config.funcInfo.canUpdate === "Y") {
                // editPassword();
            } else if(tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const update = (model,e) => {
        e.stopPropagation();
        messageShowHandler();
        searchById(model.userId)
        setTabIndex("2");
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            userId: model.userId ?? '',
            userCode: model.userCode ?? '',
            userName: model.userName ?? '',
            newPwd: '',
            pwd: ''
        });
    }


    //审核
    const audit = (model ,e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const searchById = (userId) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("user/searchById", userId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                initForm(model)
                setUserModel(model)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        values.userId = userModel.userId;
        values.lastUpdatedDate = userModel.lastUpdatedDate;
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("user/updatePwd", values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if(state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const validatePassword = async (_, value) => {
        if (!value) {
            throw new Error(trans.newPwdIsNoNull[Config.backLang]);
        }
        // 密码长度至少为8位
        if (value.length < 8) {
            throw new Error(trans.passwordMin[Config.backLang]);
        }
        // 密码需要包含大写字母、小写字母、数字和特殊字符
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[()`!@#$%^&*_\-+=|{}[\]:;'<>,.?])[A-Za-z\d()`!@#$%^&*_\-+=|{}[\]:;'<>,.?]+$/;
        if (!passwordRegex.test(value)) {
            throw new Error("The New Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character.");
        }
        return Promise.resolve();
    };

    const columns = [
        {
            title: trans.userId[Config.backLang],
            dataIndex: 'userId',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'userId') },
        },
        {
            title: trans.userCode[Config.backLang],
            dataIndex: 'userCode',
            className: 'tableWidth17',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'userCode') },
        },
        {
            title: trans.userName[Config.backLang],
            dataIndex: 'userName',
            className: 'tableWidth18',
        },
        {
            title:  trans.phone[Config.backLang],
            dataIndex: 'phone',
            className: 'tableWidth18',
        },
        {
            title:  trans.email[Config.backLang],
            dataIndex: 'email',
            className: 'tableWidth26',
        },
        {
            title: trans.activeInd[Config.backLang],
            dataIndex: 'activeInd',
            className: 'tableWidth12',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'activeInd') },
            render: (text) => ContextHandler.getMapValueTransalation('indsTransalation', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            fixed:'right',
            width: 213,
            className: ' sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record ,e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.updatePassword[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record,e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    return (
        <div id="container" className="template wilPwdManage">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.sysManage[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 错误信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 審核彈框 */}
                    {isLeave ?  <PopupFrame close={leaveFrameClose} type='leave'/> : null}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel}/>
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.userId[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.userId[Config.backLang]} value={searchModel.userIds}
                                            onChange={(e) => searchChange('userIds', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.userCode[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.userCode[Config.backLang]} value={searchModel.userCode}
                                            onChange={(e) => searchChange('userCode', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.userName[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.userName[Config.backLang]} value={searchModel.userName}
                                            onChange={(e) => searchChange('userName', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                            <div className="sysLineEight" />
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowKey="userId" //Key值
                                    scroll={{ x: 1350 }}
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                      //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,                          //默认当前页为1
                                        size:"small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.updatePassword[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.userId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="userId"
                                            >
                                                <Input type="text" placeholder={trans.userId[Config.backLang]} disabled/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.userCode[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="userCode"
                                            >
                                                <Input type="text" placeholder={trans.userCode[Config.backLang]} disabled/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysRow">
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.userName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="userName"
                                            >
                                                <Input type="text" placeholder={trans.userName[Config.backLang]} disabled/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.newPwd[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="newPwd"
                                                rules={[
                                                    { validator: validatePassword }
                                                ]}
                                            >
                                                <Input type="password" placeholder={trans.newPwd[Config.backLang]} maxLength={20}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.pwd[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="pwd"
                                                dependencies={['newPwd']}
                                                rules={[
                                                    { required: true, message: trans.pwdIsNoNull[Config.backLang] },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            if (!value || getFieldValue('newPwd') === value) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error(trans.pwdInconformity[Config.backLang]));
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input type="password" placeholder={trans.pwd[Config.backLang]} maxLength={20}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

export default WilPwdManage;